<template>
  <div v-if="visible" class="dialog-mask">
    <div class="dialog-container">
      <!-- 关闭按钮现在放在dialog-container内部 -->
<!--      <button-->
<!--          class="close-btn"-->
<!--          @click="handleClose"-->
<!--          aria-label="关闭弹窗"-->
<!--      >×</button>-->
      <img src="../assets/img/close2.png"  class="close-btn"
           @click="handleClose"
           aria-label="关闭弹窗">
      <!-- 弹窗内容保持不变 -->
      <h2 class="dialog-title">{{ title }}</h2>
      <h4 class="dialog-sub-title">查阅简介信息 索取内容密码</h4>
      <div class="dialog-body">
        <input
            v-model="inputValue"
            class="dialog-input"
            type="text"
            :placeholder="placeholder"
        >
      </div>
      <div class="dialog-footer">
        <button class="btn cancel-btn" @click="handleCancel">取消</button>
        <button class="btn confirm-btn" @click="handleConfirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 脚本部分保持不变
  name: 'Dialog',
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: '提示'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputValue: ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleCancel() {
      this.$emit('cancel')
      this.inputValue = ''
    },
    handleConfirm() {
      if (this.inputValue.trim()) {
        this.$emit('confirm', this.inputValue.trim())
        this.inputValue = ''
      }
    }
  }
}
</script>

<style scoped>
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 修改关闭按钮定位样式 */
.close-btn {
  position: absolute;
  top: -40px;  /* 上移超出容器 */
  right: -40px; /* 右移超出容器 */
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  font-size: 28px;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  z-index: 1; /* 确保在弹窗上方 */
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
  line-height: 0.5;
}

.close-btn:hover {
  transform: rotate(90deg) scale(1.1);
  color: #ff4444;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
}

.dialog-container {
  position: relative; /* 为关闭按钮提供定位基准 */
  width: 600px;
  height: 424px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: slide-in 0.3s ease;
}

/* 其他样式保持不变 */
.dialog-title {
  text-align: center;
  margin-top: 62px;
  font-size: 28px;
  color: #202020;
  font-weight: 500;
}
.dialog-sub-title {
  text-align: center;
  margin-top: 22px;
  font-size: 16px;
  color: #b8bbba;
  font-weight: 500;
}

.dialog-body {
  height: 68px;
  width: 600px;
  padding: 0 50px; /* 与容器padding保持一致 */
  margin: 50px 0;
  box-sizing: border-box;
}

.dialog-input {
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  border: 1px solid #e0e0e0;
  border-radius:20px;
  font-size: 34px;
  transition: border-color 0.3s;
  display: block;
  margin: 0 auto;
  box-sizing: border-box;
  color: #202020;
  padding-left: 34px;
}

.dialog-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 4px rgba(64, 158, 255, 0.3);
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 66px;
  margin-left: 50px;
  margin-right: 50px;
}

.btn {
  min-width: 234px;
  height: 68px;
  padding: 12px 24px;
  border: none;
  border-radius: 34px;
  font-size: 24px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.cancel-btn {
  background: #e0dfdfdf;
  color: #000;
}

.cancel-btn:hover {
  background: #ebebeb;
}

.confirm-btn {
  background: #f6451b;
  color: #fff;
}

.confirm-btn:hover {
  background: #f6451b;
}

@keyframes slide-in {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>